﻿import controller from "../../../../Resources/Scripts/_Shared/Controller";
import { permits } from "../../_Shared/Scripts/Endpoints";
import { createConfirm } from "../../../../resources/scripts/_shared/confirm";
import {
    appendContent,
    openOverlay,
} from "../../_Shared/Scripts/MyAimoParkOverlay";
import { paramsToObject } from "../../../../Resources/Scripts/_Shared/history";
import { waitingLists } from "./Endpoints";

function myAimoParkPreliminaryOrderPage(context) {
    const htmlElement = document.querySelector("html");
    const overlayContext = document.querySelector(
        "[data-controller=myaimopark-overlay]"
    );
    const approveButtons = context.querySelectorAll(".approve__button");
    const adminstrateButtons = context.querySelectorAll(
        ".administrate-request"
    );
    const adminstrateApprovalButtons = context.querySelectorAll(
        ".administrate-approval"
    );

    const urlParams = new URL(window.location.href);
    urlParams.searchParams.delete("waitingListId");
    urlParams.searchParams.delete("requestId");
    window.history.replaceState({}, "", urlParams.toString());

    const endpointSettings = context.dataset.endpointUrl
        ? { WaitingListPageUrl: context.dataset.endpointUrl }
        : {};

    if (
        !approveButtons.length & !adminstrateButtons.length &&
        !adminstrateApprovalButtons.length
    )
        return;

    const lang = document.querySelector("html").getAttribute("lang");

    function init() {
        const approveOrder = async (e) => {
            const orderId = e.target.dataset.orderId;
            const myAimoParkStartPageBlock = e.target.closest(
                ".myaimoparkstartpage__block"
            );
            const preliminaryOrderList = e.target.closest(
                ".myaimoparkpreliminaryorder__list"
            );

            const nextElem = preliminaryOrderList?.nextElementSibling;
            const entryLink = nextElem?.querySelector("a");

            let counter = entryLink
                ? +entryLink.innerText.match(/\d+/)?.[0]
                : null;

            const errorSettings = {
                close: preliminaryOrderList.dataset.confirmCloseText,
                cancel: null,
                confirm: preliminaryOrderList.dataset.confirmOkText,
            };

            const response = await permits.approvePreliminaryOrder(
                { orderId },
                lang
            );

            if (response.status == 200) {
                setTimeout(() => {
                    if (
                        preliminaryOrderList.querySelectorAll("LI").length ===
                            1 &&
                        myAimoParkStartPageBlock
                    )
                        myAimoParkStartPageBlock.remove();
                    else if (
                        preliminaryOrderList.querySelectorAll("LI").length === 1
                    )
                        preliminaryOrderList.innerHTML = "";
                    else e.target.parentNode.parentNode.remove();
                    if (entryLink && counter !== null) {
                        entryLink.innerText = entryLink.innerText.replace(
                            /\(.*?\)/,
                            `(${--counter})`
                        );
                    }
                }, 500);
                location.reload();
            } else {
                const errorMessage =
                    response.body.ErrorMessage ||
                    preliminaryOrderList.dataset.confirmErrorText;
                createConfirm(
                    preliminaryOrderList.dataset.confirmErrorHeading,
                    errorMessage.includes("</strong>")
                        ? errorMessage.split("</strong>")[1]
                        : errorMessage,
                    errorSettings,
                    () => {
                        return;
                    }
                );
            }
        };

        for (let i = 0; i < approveButtons.length; i++) {
            approveButtons[i].addEventListener("click", approveOrder);
        }

        const closeDropdowns = (event, closeAll) => {
            const openDropDowns = Array.prototype.slice.call(
                document.querySelectorAll(".open")
            );
            if (openDropDowns) {
                openDropDowns.forEach((element) => {
                    if (
                        closeAll ||
                        (element != event.target &&
                            !event.target.classList.contains("valuelist") &&
                            !event.target.parentElement.classList.contains(
                                "valuelist"
                            ))
                    )
                        element.classList.remove("open");
                });
            }
        };

        const administrateWaitingList = async (e) => {
            console.log("e: ", e);
            closeDropdowns(e);
            const waitingListItemId = e.target.dataset.requestId;
            const facility = e.target.dataset.facility;
            const city = e.target.dataset.city;
            if (waitingListItemId) {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set("waitingListId", waitingListItemId);
                const newUrl =
                    window.location.origin +
                    window.location.pathname +
                    "?" +
                    urlParams.toString();
                history.replaceState(
                    paramsToObject(urlParams),
                    document.title,
                    newUrl
                );

                openWaitingListOverlay(facility, city, waitingListItemId);
            } else if (e.target.getAttribute("aria-haspopup")) {
            }
        };

        const administrateWaitingListApproval = async (e) => {
            console.log("e: ", e);
            closeDropdowns(e);
            const approvalId = e.target.dataset.requestId;
            const facility = e.target.dataset.facility;
            const city = e.target.dataset.city;
            if (approvalId) {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set("requestId", approvalId);
                const newUrl =
                    window.location.origin +
                    window.location.pathname +
                    "?" +
                    urlParams.toString();
                history.replaceState(
                    paramsToObject(urlParams),
                    document.title,
                    newUrl
                );

                openWaitingListApprovalOverlay(facility, city, approvalId);
            } else if (e.target.getAttribute("aria-haspopup")) {
            }
        };

        for (let i = 0; i < adminstrateButtons.length; i++) {
            adminstrateButtons[i].addEventListener(
                "click",
                administrateWaitingList
            );
        }

        for (let i = 0; i < adminstrateApprovalButtons.length; i++) {
            adminstrateApprovalButtons[i].addEventListener(
                "click",
                administrateWaitingListApproval
            );
        }
    }

    async function openWaitingListOverlay(
        heading,
        subHeading,
        waitingListItemId
    ) {
        openOverlay(overlayContext, {
            heading,
            subHeading,
            clearContent: true,
        });

        const waitingListInformation = await waitingLists
            .getWaitingListInformation({
                ...endpointSettings,
                WaitingListItemId: waitingListItemId,
            })
            .catch((err) => err);

        if (waitingListInformation.status === 200) {
            if (htmlElement.classList.contains("map-overlay-active")) {
                appendContent(
                    overlayContext,
                    null,
                    waitingListInformation.body
                );
            }
        }
    }

    async function openWaitingListApprovalOverlay(
        heading,
        subHeading,
        approvalId
    ) {
        openOverlay(overlayContext, {
            heading,
            subHeading,
            clearContent: true,
        });

        const approvalInformation = await waitingLists
            .getWaitingListApprovalInformation({
                ...endpointSettings,
                RequestId: approvalId,
            })
            .catch((err) => err);

        if (approvalInformation.status === 200) {
            if (htmlElement.classList.contains("map-overlay-active")) {
                appendContent(overlayContext, null, approvalInformation.body);
            }
        }
    }

    return {
        init,
    };
}

controller.add(
    "myaimopark-preliminary-order-page",
    myAimoParkPreliminaryOrderPage
);
